export const checkForInvestmentMix = (investmentMaster, dataName) => {
    let numberOfInvests = 0;
    let investMixArr = [];
    let investDiverseArr = [];
    let additionalText = "";
    for (let i=0; i<investmentMaster.length; i++){
        let investClass = investmentMaster[i].investmentType;
        if (investmentMaster[i].investmentClass){
            investClass = investmentMaster[i].investmentClass;
        }
        if (!investMixArr.includes(investClass)){
            investMixArr.push(investClass);
        }
        let investType = investmentMaster[i].investmentType;
        if (!investDiverseArr.includes(investType)){
            investDiverseArr.push(investType);
        }        
    }
    if (dataName === "investmentMix"){
        if (investMixArr.length >= 2 || investMixArr.includes("Balanced")){
            numberOfInvests = 2;
            additionalText = "Your portfolio is currently diversified."
        }else{
            if (investMixArr.length === 1){
                numberOfInvests = 1;
                if (investMixArr.includes("stock")){
                    additionalText = "You own stocks, but you do not currently own any bonds.";
                }else{
                    additionalText = "You own bonds, but you do not currently own any stocks.";
                }
            }else{
                additionalText = "You have not made any investments.";
            }
        }
    }else{
        if (investDiverseArr.length >= 4){
            numberOfInvests = 4;
            additionalText = "Your portfolio is fully diverse."
        }else{
            numberOfInvests = investDiverseArr.length;
            if (investDiverseArr.length === 0){
                additionalText = "You have not made any investments.";
            }else{
                additionalText = "Your portfolio currently has at least 1 " + investDiverseArr.join(", ") 
                    + ".";
            }
        }
    }
    
    const returnObj = {numberOfInvests: numberOfInvests, additionalText: additionalText};
    return returnObj;
}
export default checkForInvestmentMix;